import Model from '@/Models/Contracts/Model';
/**
 * @property {string} id
 * @property {string} name
 * @property {string} address
 * @property {string} postcode
 * @property {string} city
 * @property {string} country
 */
export default class Company extends Model {
    resource() {
        return 'companies';
    }
}
